<template>
	<div>
		<div class="swiper-about-banner">
			<div class="swiper-wrapper" ref="video">
				<div class="swiper-slide" v-for="(item,index) in list" :key="index" >
					<img :src="item.url" v-if="item.type==1" />
					<!-- <video :src="item.url" v-else :autoplay="true" muted loop></video> -->
					<template v-else >
						<!-- @ready="onPlayerReady" :playsinline="true" :webkit-playsinline="true" -->
						<!-- <video-player :ref="'videoPlayer'+index" :options="playerOptionsFun(item,index)" webkit-playsinline playsinline x5-video-player-type="h5-page">
						</video-player> -->
						<video :src="item.url" v-if="headerShow"  muted loop   :poster="item.url+'?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
						<video :src="item.url" v-else muted loop webkit-playsinline playsinline x5-video-player-type="h5-page" x5-playsinline="true" controls preload="auto"  :poster="item.url+'?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
					</template>

					<div class="swiper-slide-dw" :class="activeIndex==index?' ':''" style="animation-duration: 1s;">
						<!-- <div class="swiper-slide-dw-name">{{item.name}}</div>
						<div class="swiper-slide-dw-cen">{{item.cen}}</div> -->
						<div class="swiper-slide-dw-name">
							<div v-for="(itema,indexa) in item.other.bigTitle" :key="indexa">
								{{itema.title}}
							</div>
						</div>
						<div class="swiper-slide-dw-cen">
							<div v-for="(itema,indexa) in item.other.smallTitle" :key="indexa" :style="{
								height:itema.title?'':'20px',
								letterSpacing: '0.1em'
							}">
								{{itema.title}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		// props: {
		// 	list: {
		// 		typeof: Array,
		// 		default: []
		// 	}
		// },
		data() {
			return {
				activeIndex: 0,
				playerOptions: {
					playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
					autoplay: true, // 如果为true,浏览器准备好时开始回放。
					muted: true, // 默认情况下将会消除任何音频。
					loop: true, // 是否视频一结束就重新开始。
					preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					language: 'zh-CN',
					aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
					fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
					sources: [{
						type: "video/mp4", // 类型
						src: '' // url地址
					}],
					poster: '', // 封面地址
					notSupportedMessage: this.$t('i18n_71'), // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
					controlBar: {
						timeDivider: true, // 当前时间和持续时间的分隔符
						durationDisplay: true, // 显示持续时间
						remainingTimeDisplay: false, // 是否显示剩余时间功能
						fullscreenToggle: true // 是否显示全屏按钮
					}
				},
				list:[]
			}
		},
		mounted() {
			
		},
		methods: {
			setList(e){
				let t = this;
				this.list=e;
				console.log(e,"传递过来的列表");
				// autoplay: {
				// 	delay: 3000,
				// 	disableOnInteraction: false,
				// },
				
				const mySwiper = new this.$swiper('.swiper-about-banner', {
					// 方向
					direction: 'horizontal',
					// 自动播放
					autoplay: false,
					on: {
						slideChangeTransitionStart(e) {
							t.activeIndex = this.activeIndex;
						},
				
					},
				});
				this.$nextTick(function(){
					console.log(t.$refs['video'],"5------")
					console.log(t.$refs['video'].querySelectorAll('.swiper-slide video'),"*------")
					t.$refs['video'].querySelectorAll('.swiper-slide video')[t.activeIndex].play()
				})
			},
			playerOptionsFun(e, a) {
				let playerOptions = this.playerOptions;

				playerOptions.sources[0].src = e.url;
				// playerOptions.sources[0].src='https://aohuacbi.oss-cn-qingdao.aliyuncs.com/20230515/02-%E5%85%B3%E4%BA%8E%E6%BE%B3%E5%8D%8E-banner.mp4';
				return playerOptions
			},
			onPlayerReady() {
				console.log(this.$refs['videoPlayer' + this.activeIndex][0])
				const videoPlayer = this.$refs['videoPlayer' + this.activeIndex][0].$el

				videoPlayer.on('fullscreenchange', this.onFullscreenchange)
			},
			onFullscreenchange() {
				const videoPlayer = this.$refs['videoPlayer' + this.activeIndex][0].$el
				console.log(videoPlayer)
				if (videoPlayer.isFullscreen()) {
					videoPlayer.el().classList.add('vjs-fullscreen')
				} else {
					videoPlayer.el().classList.remove('vjs-fullscreen')
				}
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	/*播放按钮设置成宽高一致，圆形，居中*/


	::v-deep {
		.video-js .vjs-tech {
			object-fit: contain;
			// height: 675px;
		}

		// .vjs-text-track-display{

		// }
		.vjs-poster {
			background-size: cover;
		}

		.video-player {
			height: 675px !important;
		}

		.video-js.vjs-fluid,
		.video-js.vjs-16-9,
		.video-js.vjs-4-3,
		.video-js.vjs-9-16,
		.video-js.vjs-1-1 {
			height: 675px !important;
		}

		.vjs_video_3-dimensions.vjs-fluid {
			padding: 0;
		}

		.vjs-big-play-button {
			outline: none;
			border: none;
			width: 66px;
			height: 66px !important;
			background-color: rgba(0, 0, 0, 0) !important;
			left: 50% !important;
			top: 50% !important;
		}

		.video-js .vjs-big-play-button .vjs-icon-placeholder:before {
			content: '';
			width: 66px;
			height: 66px;
			background: url('~@/assets/index/play.png') no-repeat;
			background-size: 100% 100%;
		}

		// .vjs-tech{
		// 	width: 100% !important;
		// 	height: 600px !important;
		// 	object-fit: cover !important;
		// }
	}

	.swiper-about-banner {
		overflow: hidden;
		height: 675px;
	}

	.swiper-slide {
		position: relative;

		img {
			width: 100%;
			height: 675px;
			object-fit: cover;
		}
		video {
			width: 100%;
			height: 675px;
			object-fit: cover;
		}

		.videoBox {
			// width: 100%;
			// height: 600px;
			// video {
			// 	width: 100%;
			// 	height: 600px !important;
			// 	object-fit: cover;
			// }

		}


		.swiper-slide-dw {
			position: absolute;
			top: 60px;
			left: 0;
			z-index: 999;
			width: 100%;
			text-align: center;

			.swiper-slide-dw-name {
				font-size: 36px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #FFFFFF;
			}

			.swiper-slide-dw-cen {
				margin-top: 30px;
				font-size: 24px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #FFFFFF;
			}
		}
	}

	@media screen and (max-width:1200px) {
		.swiper-about-banner {
			height: 300px !important;
		}

		.swiper-slide {

			img {
				height: 300px !important;
			}
		}
		::v-deep {
			.video-player {
				height: 300px !important;
			}
			
			.video-js.vjs-fluid,
			.video-js.vjs-16-9,
			.video-js.vjs-4-3,
			.video-js.vjs-9-16,
			.video-js.vjs-1-1 {
				height: 300px !important;
			}
		}
		
		
	}
</style>